export default __webpack_public_path__ + "static/media/softwone.7fee8b76.svg";